import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-source-metrics',
  templateUrl: './help-source-metrics.component.html',
  styleUrls: ['./help-source-metrics.component.scss']
})
export class HelpSourceMetricsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
